<script>
    import Icon from 'svelte-awesome';
    import { phone, envelope } from 'svelte-awesome/icons';

    const contactPhone = 'tel:8018919112';
    const email = 'MAILTO:alamodestudios801@gmail.com';
</script>
<div id="Contact" class="contact-us">
    <div class="contact-inner">
        <p class="text-contact">We enjoy working with talented people.</p>
        <p class="text-contact">If you think you'll be a good fit with us, let us know why. Better yet, show us!</p>
        <a class="contact-buttons" href="{contactPhone}">Give Us a Call <Icon data={phone} style="height: 25px; width: 25px; vertical-align: text-top;"/></a>
        <a class="contact-buttons" href="{email}">Email Us <Icon data={envelope} style="height: 20px; width: 20px; vertical-align: text-top;"/></a>
    </div>
</div>
